import { BrowserRouter } from "react-router-dom";

import { datadogRum } from "@datadog/browser-rum";
import { createRoot } from "react-dom/client";

import { LogProvider } from "./common/log/logProvider";
import { confirmNavigation } from "./components/admin/settings/roles/navigationConfirmation";
import { App } from "./components/app/app";
import { NuqsAdapter } from "./reactRouterV5Adapter";
//TODO: Remove this when removing ant-design
import "@ant-design/v5-patch-for-react-19";

// global.__src = __dirname;

if (process.env.REACT_APP_DATADOG_ENABLED === "true") {
  datadogRum.init({
    applicationId: "6ee63b18-40d8-4679-b08a-1fbe4e4ba31c",
    clientToken: "pub5180b6df804df179bc52d4462fbc4d27",
    site: "datadoghq.com",
    service: "alaffia-app",
    env: process.env.REACT_APP_DATADOG_ENV ?? "local",
    version: process.env.REACT_APP_DATADOG_VERSION ?? "local",
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    trackResources: true,
    trackLongTasks: true,
    trackUserInteractions: true,
  });
}

const container = document.getElementById("root");
const root = createRoot(container!, {
  onUncaughtError: (error, errorInfo) => {
    console.error("Uncaught React error:", error, errorInfo.componentStack);
    if (process.env.REACT_APP_DATADOG_ENABLED === "true") {
      datadogRum.addError(error, {
        source: "react-uncaught",
        componentStack: errorInfo.componentStack,
      });
    }
  },
  onCaughtError: (error, errorInfo) => {
    console.warn(
      "Caught React error (Error Boundary):",
      error,
      errorInfo.componentStack,
    );
    if (process.env.REACT_APP_DATADOG_ENABLED === "true") {
      datadogRum.addError(error, {
        source: "react-error-boundary",
        componentStack: errorInfo.componentStack,
      });
    }
  },
});

root.render(
  <NuqsAdapter>
    <LogProvider>
      <BrowserRouter getUserConfirmation={confirmNavigation}>
        <App />
      </BrowserRouter>
    </LogProvider>
  </NuqsAdapter>,
);
